namespace NotificationTypes {

    export interface NotificationEntity_Base extends more.EntityAPIResultExtended, MultilangEnabledEntityMixin {
        name_internal: string;
        subject: string;
        message: string;        
        is_confirmation_needed: boolean;
        is_confirmed: boolean;
        priority: number;
        is_read: boolean;
        ref_subject_entity: more.EntityAPIResult;
        subject_entity_classname: string;
        subject_entity_displayname: string;
        date_notification: Date;
        date_subject_start: Date;
        date_subject_end: Date;
        date_expiration: Date;
        alert_date: Date;
        tmp_weblink: string;
        type: NotificationType
        iconclass: string;
    }

    export interface ModuleSettings {
        NotificationCenterTargetnode: string;
        PullInterval: number;
        InitialPullDelay: number;
    }

    export type NotificationType = "pushmessage" | "reminder";
    export type UpdateAction = "read" | "unread" | "confirmed" | "unconfirmed";

    export interface NotificationEntity_Pushmessage extends NotificationEntity_Base {
        
    }
    export interface NotificationEntity_Reminder extends NotificationEntity_Base {
        alert_date: Date;
    }


    export interface PullRequestData {
        earliestDate: Date,
        includeConfirmed: boolean,
        includeRead: boolean
        includeExpired: boolean
    }
    export interface PullResponseData {
        //unread: Array<NotificationEntity_Base>;
        ////unconfirmed: Array<NotificationEntity_Base>;
        new: Array<NotificationEntity_Base>;
        updated: Array<NotificationEntity_Base>;
        completeList: Array<NotificationEntity_Base>;
        unreadCount: number

    };

}

enum NotificationTopics {
    "Updated_List" = "/Notifications/Updated",
    "Updated_Single" = "/Notifications/Updated/",
    "Loaded" = "/Notifications/Loaded",
    "SetConfirmed" = "/Notifications/Confirm",
    "SetRead" = "/Notifications/SetRead",
    "SetUnread" = "/Notifications/SetUnRead"
}

export {
    NotificationTypes,
    NotificationTopics
}